import { Toast } from "src/app/ui/components/toast/toast";
import { Cluster } from "src/app/ui/models/domains/pbm/clusters/cluster.model";
import { ExportOrderKey } from "src/app/ui/models/domains/pbm/exports/export-order-key";
import { BaseSasFileExportRequest } from "src/app/ui/models/domains/pbm/exports/file-export-order-request";
import { FileExportService } from "src/app/ui/services/file-export.service";
import { ClustersService } from "src/app/ui/services/pbm/clusters.service";

export class SearchClusterExportOrderRequest extends BaseSasFileExportRequest {
  constructor(
    private clusterService: ClustersService,
    toast: Toast,
    fileExportService: FileExportService,
    private cluster: Cluster) {
    super(fileExportService, toast)
  }


  public getFileExportName(): string {
    return `Cluster-${this.cluster.getName()}`;
  }


  public async orderExport(): Promise<ExportOrderKey> {
    const exportOrderKey = await this.clusterService.exportCluster(this.cluster);
    return exportOrderKey;
  }
}
